<template>
  <v-form lazy-validation @submit.prevent="next">
    <v-layout wrap row justify-center>
      <v-flex xs12 sm8 px-4>
        <v-layout wrap row>
          <v-flex xs12 style="padding-bottom: 10px;">
            <v-text-field
              label="Nombre del pago"
              v-model="v.name.$model"
              outline
              :error-messages="nameErrors"
            />
          </v-flex>
          <v-flex xs12 style="padding-bottom: 10px;">
            <v-select
              :items="concepts"
              item-text="name"
              item-value="id"
              return-object
              v-model="v.paymentConcept.$model"
              label="Selecciona el concepto"
              :errorMessages="conceptErrors"
            />
          </v-flex>
          <v-flex xs12>
            <!--<DateTimePicker
              :errorMessages="dueDateErrors"
              titleDate="Fecha límite"
              titleTime="Hora límite"
              v-model="v.dueDate.$model"
              :min="today"
            />-->
            <VueTimePickerTool
              :errorMessages="dueDateErrors"
              titleDate="Fecha límite de pago"
              titleTime="Hora Limite"
              v-model="v.dueDate.$model"
              class="pickPoll"
              style="font-size:1.1em; margin-top: 3px; margin-left:-5px;"
              :min="today"
              location="up"
            />
          </v-flex>
          <v-flex xs12>
            <v-checkbox
              color="primary"
              id="split"
              v-model="v.metadata.$model.split"
              label="Dividir pago entre padres"
            ></v-checkbox>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import DateTimePicker from "../Notices/Tools/DateTimePicker2";
import VueTimePickerTool from "../Notices/Tools/VueDateTimePicker";

export default {
  props: ["v"],
  components: {
    DateTimePicker,
    VueTimePickerTool,
  },
  data: () => ({
    concepts: [],
    today: ""
  }),
  methods: {
    getConcepts() {
      this.$store
        .dispatch("paymentConcepts/getConcepts")
        .then((response) => {
          this.concepts = response.data.items;
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.getConcepts();
    this.today = new Date().toLocaleDateString("sv-SE");
  },
  computed: {
    nameErrors() {
      if (this.v.name.$dirty && !this.v.name.$model) {
        return ["Nombre requerido"];
      }
      return [];
    },
    dueDateErrors() {
      if (this.v.dueDate.$dirty && !this.v.dueDate.$model) {
        return ["Fecha límite requerida"];
      }
      return [];
    },
    conceptErrors() {
      if (this.v.paymentConcept.$dirty && !this.v.paymentConcept.$model.id) {
        return ["Concepto requerido"];
      }
      return [];
    },
  },
};
</script>

<style>
.pickPoll .vue__time-picker input.display-time  {
	/* border: 1px solid #d2d2d2;
	width: 10em;
	padding: .3em .5em;
	font-size: 1em; */
	height: 40px;
}
</style>
